import { FC, useMemo } from "react";
import clsx from "clsx";
import { Bag2Icon, Trunk2Icon, VehicleIcon, Wallet2Icon, WorldIcon } from "@/shared/icons";
import { BaseIconProps } from "@/shared/icons/BaseIcon";
import { OwnerType } from "@/domains/inventory/constants/ownerType";
import InventoryCloseButton from "@/domains/inventory/components/InventoryCloseButton";

type Props = {
  ownerType: OwnerType;
  iconClassName?: string;
  onClose: () => void;
  className?: string;
};

const ownerTypeLabel: Record<OwnerType, string> = {
  [OwnerType.Bag]: "Рюкзак",
  [OwnerType.VehicleTrunk]: "Багажник",
  [OwnerType.Environment]: "Окружение",
  [OwnerType.Character]: "",
  [OwnerType.Wallet]: "Портмоне",
  [OwnerType.Confiscation]: "",
  [OwnerType.Trade]: "",
  [OwnerType.EstateSafe]: "",
  [OwnerType.GarbageContainer]: "Мусорный бак",
  [OwnerType.VehicleGloveBox]: "Бардачок",
};

const icon: Record<OwnerType, FC<BaseIconProps>> = {
  [OwnerType.Bag]: Bag2Icon,
  [OwnerType.VehicleTrunk]: Trunk2Icon,
  [OwnerType.Environment]: WorldIcon,
  [OwnerType.Character]: undefined,
  [OwnerType.Wallet]: Wallet2Icon,
  [OwnerType.Confiscation]: undefined,
  [OwnerType.Trade]: undefined,
  [OwnerType.EstateSafe]: undefined,
  [OwnerType.GarbageContainer]: undefined,
  [OwnerType.VehicleGloveBox]: VehicleIcon,
};

export default function InventoryCommonHeader({
  ownerType,
  iconClassName,
  className,
  onClose,
}: Props) {
  return (
    <div
      className={clsx(
        "px-7.5 h-[3.75rem] w-full",
        "flex items-center justify-between gap-1.5 bg-gradient-to-r from-[#2C2C2C]/30 via-transparent to-dark-800/60",
        className,
      )}
    >
      <div className="flex items-center gap-2.5">
        {icon[ownerType]({ size: 20, className: iconClassName })}
        <div className="text-18 font-medium">{ownerTypeLabel[ownerType]}</div>
      </div>
      <InventoryCloseButton onClick={onClose} />
    </div>
  );
}
